module.exports = __webpack_public_path__ + "assets/images/scene-3_a32c31e6f21bbd599df4c13f3caad005.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stages/stage-three/croma-abeldo-dialogs/scene-3.png
// module id = 246
// module chunks = 0